import { PlayersModule } from '@/modules/fantasy/players';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  sportType: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/fantasy/players')({
  validateSearch: searchSchema,
  component: PlayersPage,
});

function PlayersPage() {
  return <PlayersModule />;
}
